module.exports = __webpack_public_path__ + "img/ss.b93ee45f.png";